/** @jsx jsx */
import { Button } from '@datacamp/waffles/button';
import { VideoCamera } from '@datacamp/waffles/icon';
import { Tooltip } from '@datacamp/waffles/tooltip';
import { jsx } from '@emotion/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { headerIconButton } from '../../styles/campus/buttonOverrides';

type Props = {
  onClick: (...args: any[]) => any;
};

const PeekVideoButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Tooltip content={t('PeekVideoButton.label')} placement="bottomRight">
      <Button
        data-cy="header-video"
        onClick={onClick}
        aria-label={t('PeekVideoButton.label')}
        css={headerIconButton}
        icon={<VideoCamera />}
        variant="plain"
      />
    </Tooltip>
  );
};

export default PeekVideoButton;
